import esLocale from 'element-ui/lib/locale/lang/es'
import home from './es/home'

const es = {
    language: 'Español',
    message: {
        'home': {
            ...home,
            enterEmail: 'Por favor, introduce el correo electrónico',
            save: 'Guardar',
            saveSuccess: 'Guardado con éxito',
            pointHistory: 'Historial de puntos',
            type: 'Tipo',
            remark: 'Observación',
            pendingComment: 'Pendiente de valorar',
            commented: 'Valorado',
            selectDate: 'Seleccionar fecha',
            loginSuccess: 'Inicio de sesión correcto',
            loginFail: 'Error al iniciar sesión',
            close: 'Cerrar',
            required: 'Obligatorio',
            nickname: 'Apodo',
            enterNickname: 'Por favor, introduce un apodo',
            gender: 'Género',
            male: 'Hombre',
            female: 'Mujer',
            secret: 'Confidencial',
            birthday: 'Cumpleaños',
            checkoutLoadFailed: 'Error al cargar la información de pago. Inténtalo de nuevo más tarde.',
            checkoutErrorTitle: 'Aviso',
            goAddAddress: 'Añadir dirección de envío',
            shop_order_selectOrAddAddress: 'Por favor, añade primero una dirección de envío y márcala como predeterminada antes de finalizar la compra.',
            shop_order_cartEmpty: 'El carrito está vacío, no se puede finalizar la compra.',
            shop_order_cartHasNotActive: 'Hay artículos no publicados o no válidos, no se puede finalizar la compra.',
            shop_order_cartHasNotMarketable: 'Hay artículos retirados, no se puede finalizar la compra.',
            shop_order_cartHasLowStock: 'Stock insuficiente, no se puede finalizar la compra.',
            shop_order_cartHasExpiredGoods: 'Algunos artículos de la tienda han caducado, no se puede finalizar la compra.',
            shop_order_typeIsNull: 'No se reconoce el tipo de pedido, comprueba el tipo de artículo.',
            shop_order_goodsNotFound: 'La información del producto no existe o ha sido eliminada.',
            shop_order_giftNotForSale: 'Los artículos de regalo no se pueden comprar directamente.',
            common_message_badRequest: 'Solicitud no válida, comprueba el producto y los parámetros.',
        },
    },
    '手机号码最小长度为8位': 'La longitud mínima del número de teléfono móvil es de 8 dígitos',
    '邮箱账号名称最小长度为6位': 'La longitud mínima del nombre de la cuenta de correo electrónico es de 6 caracteres',
    '邮箱只能包含英文，数字等字符': 'El buzón solo puede contener caracteres como inglés y números',
    '请选择正确的收货地址': 'Seleccione la dirección de envío correcta',
    Dict_language_status_0: 'Desactivado',
    Dict_language_status_1: 'Activado',
    Dict_member_label_type_1: 'Etiqueta condicional',
    Dict_member_label_type_2: 'Etiqueta manual',
    Dict_member_level_type_0: 'Nivel de consumo (LV)',
    Dict_member_level_type_1: 'Miembro de pago (VIP)',
    Dict_member_growth_action_type_1: 'Realizar pedido',
    Dict_member_growth_action_type_2: 'Inicio de sesión diario',
    Dict_member_growth_action_type_3: 'Publicar valoración',
    Dict_member_growth_action_type_4: 'Completar perfil',
    Dict_paid_member_payment_type_0: 'Pago con saldo',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Válido',
    Dict_paid_member_record_status_1: 'Caducado',
    Dict_paid_member_record_status_2: 'Reembolsado',
    Dict_point_lottery_prize_type_0: 'Puntos',
    Dict_point_lottery_prize_type_1: 'Cupón',
    Dict_point_lottery_prize_type_2: 'Premio físico',
    Dict_point_lottery_prize_type_3: 'Gracias por participar',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Correo electrónico',
    Dict_notification_channel_type_2: 'Mensaje interno',
    Dict_notification_channel_type_3: 'Notificación push',
    Dict_announcement_status_0: 'Borrador',
    Dict_announcement_status_1: 'Publicado',
    Dict_announcement_status_2: 'Retirado',
    Dict_live_permission_status_0: 'No solicitado',
    Dict_live_permission_status_1: 'En revisión',
    Dict_live_permission_status_2: 'Activado',
    Dict_live_permission_status_3: 'Rechazado',
    Dict_live_room_status_0: 'No iniciado',
    Dict_live_room_status_1: 'En directo',
    Dict_live_room_status_2: 'Finalizado',
    Dict_live_room_status_3: 'Interrupción anómala',
    Dict_live_room_type_0: 'Directo de plataforma',
    Dict_live_room_type_1: 'Directo de comerciante',
    Dict_store_type_0: 'Tienda individual',
    Dict_store_type_1: 'Tienda de empresa',
    Dict_store_sign_status_0: 'Pendiente de firma',
    Dict_store_sign_status_1: 'Firmado',
    Dict_store_sign_status_2: 'Rescindido',
    Dict_store_business_change_status_0: 'Pendiente de revisión',
    Dict_store_business_change_status_1: 'Aprobado',
    Dict_store_business_change_status_2: 'Rechazado',
    Dict_decoration_page_type_0: 'Página de inicio',
    Dict_decoration_page_type_1: 'Página de categoría',
    Dict_decoration_page_type_2: 'Página de campaña',
    Dict_decoration_page_type_3: 'Página personalizada',
    Dict_decoration_status_0: 'Borrador',
    Dict_decoration_status_1: 'Publicado',
    Dict_decoration_popup_trigger_page_0: 'Inicio de la plataforma',
    Dict_decoration_popup_trigger_page_1: 'Centro de miembros',
    Dict_decoration_popup_trigger_page_2: 'Pago correcto',
    Dict_decoration_popup_target_user_0: 'Todos los usuarios',
    Dict_decoration_popup_target_user_1: 'Miembros gratuitos',
    Dict_decoration_popup_target_user_2: 'Miembros de pago',
    Dict_decoration_popup_frequency_0: 'Una vez permanentemente',
    Dict_decoration_popup_frequency_1: 'En cada visita',
    Dict_decoration_popup_frequency_2: 'Frecuencia personalizada',
    Dict_track_event_type_page_view: 'Vista de página',
    Dict_track_event_type_click: 'Clic',
    Dict_track_event_type_add_to_cart: 'Añadir al carrito',
    Dict_track_event_type_search: 'Búsqueda',
    Dict_track_event_type_purchase: 'Compra',
    Dict_track_event_type_live_watch: 'Ver directo',
    Dict_reconcile_period_type_0: 'Diario',
    Dict_reconcile_period_type_1: 'Semanal',
    Dict_reconcile_period_type_2: 'Mensual',
    Dict_store_settlement_status_0: 'Pendiente de liquidación',
    Dict_store_settlement_status_1: 'Liquidado',
    Dict_distributor_status_0: 'Pendiente de revisión',
    Dict_distributor_status_1: 'Revisado',
    Dict_distributor_status_2: 'Rechazado',
    Dict_distribution_commission_type_0: 'Comisión directa',
    Dict_distribution_commission_type_1: 'Comisión indirecta',
    Dict_configuration_status_0: 'Desactivado',
    Dict_configuration_status_1: 'Activado',
    ...esLocale
}

export default es
